<template>
<div class="main home">
    <div class="home-box">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="按课程" name="0">
                <h1>按课程</h1>
                <div class="home-content">
                    <!-- 查询条件 -->
                    <search-item :searchInfo.sync="info" @searchList="searchList" @exportData="exportData"></search-item>
                    <!-- 表格 -->
                    <div class="table_container">
                        <el-table border :data="tableData" stripe v-loading="tableLoading" style="width: 100%" align='center'>
                            <el-table-column prop="courseName" label="课程名称" align='center'>
                            </el-table-column>
                            <el-table-column prop="priceNumber" label="公众号购买（笔）" align='center'>
                            </el-table-column>
                            <el-table-column prop="integralNumber" label="积分兑换（笔）" align='center'>
                            </el-table-column>
                            <el-table-column prop="price" label="价格（元）" align='center'>
                            </el-table-column>
                            <el-table-column prop="priceSum" label="合计（元）" align='center'>
                            </el-table-column>
                        </el-table>
                        <pagination :paginationInfo="paginationInfo" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="按讲师" name="1">
                <h1>按讲师</h1>
                <div class="home-content">
                    <!-- 查询条件 -->
                    <search-item :searchInfo.sync="info" @searchList="searchList" @exportData="exportData"></search-item>
                    <div class="table_container">
                        <el-table :data="tableData1" stripe v-loading="tableLoading" style="width: 100%" align='center'>
                            <el-table-column prop="speaker" label="讲师姓名" align='center'>
                            </el-table-column>
                            <el-table-column prop="priceNumber" label="公众号购买（笔）" align='center'>
                            </el-table-column>
                            <el-table-column prop="integralNumber" label="积分兑换（笔）" align='center'>
                            </el-table-column>
                            <el-table-column prop="integralSum" label="积分兑换总计" align='center'>
                            </el-table-column>
                            <el-table-column prop="priceSum" label="合计（元）" align='center'>
                            </el-table-column>
                        </el-table>
                        <pagination :paginationInfo="paginationInfo" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
import Pagination from "@/components/pagination";
import SearchItem from "./searchItem";
export default {
    data() {
        return {
            // 表格loading
            tableLoading: true,
            tableData: [], //表格数据
            tableData1: [], //表格数据
            paginationInfo: {
                pageIndex: 1, // 当前位于哪页
                pageTotal: 0, //表格总页数
                pageSize: 10, //每页显示条数
                pageSizes: [5, 10, 15, 20], //每页显示个数选择器的选项设置
                layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
            },
            paginationInfo_default: {
                pageIndex: 1, // 当前位于哪页
                pageTotal: 0, //表格总页数
                pageSize: 10, //每页显示条数
                pageSizes: [5, 10, 15, 20], //每页显示个数选择器的选项设置
                layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
            },
            pidList: [],
            centerDialogVisible: false,
            registerId: "",
            info: {
                date: []
            },
            activeName: '0'
        }
    },
    mounted() {
        let that = this
        this.getCOTJList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
    },
    methods: {
        //  获取销售统计信息
        getCOTJList(currpage, pageSize, info) {
            console.log(info)
            this.tableLoading = true;
            let params = {
                pageNumber: currpage,
                pageSize: pageSize,
                startTime: this.info.date ? this.info.date.length == 2 ? this.info.date[0] : '' : '',
                endTime: this.info.date ? this.info.date.length == 2 ? this.info.date[1] : '' : ''
            }
            this.tableData = []
            this.$api.courseOrderTJ(params).then(res => {
                // console.log('000', res.data.pageList)
                this.tableLoading = false;
                if (res && res.status == "OK") {
                    console.log(res)
                    this.paginationInfo.pageTotal = parseInt(res.data.total)
                    this.paginationInfo.pageIndex = res.data.pageNum
                    this.tableData = res.data.pageList
                }
            }).catch(error => {
                console.log(error)
                this.tableLoading = false;
            })
        },
        //  获取讲师统计信息
        getSTJList(currpage, pageSize, info) {
            console.log(info)
            this.tableLoading = true;
            let params = {
                pageNumber: currpage,
                pageSize: pageSize,
                startTime: this.info.date ? this.info.date.length == 2 ? this.info.date[0] : '' : '',
                endTime: this.info.date ? this.info.date.length == 2 ? this.info.date[1] : '' : ''
            }
            this.tableData1 = []
            this.$api.speakerTJ(params).then(res => {
                // console.log('000', res.data.pageList)
                this.tableLoading = false;
                if (res && res.status == "OK") {
                    console.log(res)
                    this.paginationInfo.pageTotal = parseInt(res.data.total)
                    this.paginationInfo.pageIndex = res.data.pageNum
                    this.tableData1 = res.data.pageList
                }
            }).catch(error => {
                console.log(error)
                this.tableLoading = false;
            })
        },
        searchList(e) {
            console.log(e)
            this.info = e
            if (this.activeName == '0') {
                this.getCOTJList(1, this.paginationInfo.pageSize, e)
            } else {
                this.getSTJList(1, this.paginationInfo.pageSize, e)
            }
        },
        // 上下分页
        handleCurrentChange(val) {
            // console.log('上下分页',val)
            let that = this
            this.paginationInfo.pageIndex = val
            if (this.activeName == '0') {
                this.getCOTJList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
            } else {
                this.getSTJList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
            }
        },
        // 每页显示多少条
        handleSizeChange(val) {
            // console.log('每页显示多少条',val)
            let that = this
            this.paginationInfo.pageSize = val
            if (this.activeName == '0') {
                this.getCOTJList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
            } else {
                this.getSTJList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
            }
        },
        handleClick(e) {
            console.log(this.activeName)
            this.info = {
                date : []
            }
            this.paginationInfo = JSON.parse(JSON.stringify(this.paginationInfo_default))
            if (this.activeName == '0') {
                this.getCOTJList(this.paginationInfo.pageIndex, this.paginationInfo.pageSize, this.info)
            } else {
                this.getSTJList(this.paginationInfo.pageIndex, this.paginationInfo.pageSize, this.info)
            }
        },
        exportData(info) {
            console.log(33333)
            let params = {
                startTime: this.info.date ? this.info.date.length == 2 ? this.info.date[0] : '' : '',
                endTime: this.info.date ? this.info.date.length == 2 ? this.info.date[1] : '' : ''
            }
            if (this.activeName == '0') {
                this.$api.exportCourseOrder(params).then(res => {
                    console.log(res)
                    this.$Fn.ExportExcel(res, '课程销售统计数据.xls')
                })
            } else {
                this.$api.exportSpeakerOrder(params).then(res => {
                    console.log(res)
                    this.$Fn.ExportExcel(res, '讲师销售统计数据.xls')
                })
            }
        }
    },
    components: {
        Pagination,
        SearchItem
    }
}
</script>

<style>
/* 标题 */
.menu .title1 img {
    top: 22px;
}

.menu .title1 h3 {
    font-size: 20px;
    margin-top: -14px;
}

/* 分页 */
.el-pagination button,
.el-pagination span:not([class*=suffix]) {
    padding: 0 10px;
}

.home .block-title {
    width: 100%;
    padding: 0 0 28px 20px;
    display: flex;
    align-items: center;
}

.home .block-title h3 {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #2d3039;
}

.home .a-text {
    text-decoration: underline;
    color: #1e61ce;
}

.home .block-title .btn {
    width: 180px;
    height: 35px;
    background-color: #1e61ce;
    border-radius: 20px;
    margin-left: 20px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    padding: 0;
}

.home .btn span {
    font-size: 16px !important;
    color: #fff !important;
}

.home .block-title span {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #63717A;
}

.home .top {
    width: 100%;
    padding: 0 0 10px 0;
    border-radius: 10px;
    background: #fefefe;
}

.home .top .title {
    width: 100%;
    height: 90px;
    line-height: 90px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: center;
    font-family: PingFangSC-Semibold;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #2d3039;
    border-bottom: 1px solid #f2f3f5;
}

.home .el-col {
    border-radius: 10px;
}

.home .grid-content {
    border-radius: 10px;
    /* min-height: 36px; */
}

.home .leftInfo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
}

.home .leftInfo .headPic {
    width: 165px;
    height: 165px;
    border-radius: 100%;
    border: 8px solid #fff;
    position: relative;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    box-shadow: 0px 12px 30px 0px rgba(6, 37, 117, 0.12);
}

.home .leftInfo .headPic img {
    width: 100%;

}

.home .rightInfo {
    margin-top: 10px;
    padding-right: 10px;
}

.home .rightInfo .name-text {

    margin-bottom: 20px;
    font-family: PingFangSC-Semibold;
    font-size: 26px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #2d3039;
}

.home .rightInfo .info-text img {
    width: 26px;
    height: 26px;
    margin-right: 20px;
}

.home .rightInfo .info-text {
    margin-bottom: 20px;
    font-family: PingFangSC-Medium;
    font-size: 18px;
    letter-spacing: 0px;
    color: #63717a;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    text-align: left
}

.home .rightInfo .info-text h1 {
    font-size: 20px;
    font-weight: 600;
    font-family: PingFangSC-Medium;
    color: #2d3039;
    margin-left: 10px;
    display: block;
    font-size: 90.5%;
}

.home .middle {
    width: 100%;
    border-radius: 10px;
}

.home .middle .grid-content {
    background: #fff
}

.home .title1 {
    width: 100%;
    display: flex;
    padding: 0 20px 20px 20px;
    align-items: center;
    margin-top: -10px;
    border-bottom: 1px solid #f2f3f5;
}

.home .title1 h3 {
    font-size: 20px;
    margin-top: -10px;
}

.home .title1 img {
    position: relative;
    top: 18px;
    margin-right: 10px;
}

.home .ajs-Title {
    margin-left: 20px;
}

.home .ajs {
    margin-left: 20px;
    color: #0033cf;
}

.home .left-block {
    height: 200px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px;
    /* border-right: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8; */
}

.home .right-block {
    height: 200px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px;
    border-bottom: 1px solid #d8d8d8;
}

.home .main-block {
    height: 200px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px;
    border-bottom: 1px solid #d8d8d8;
}

/*案件办理天数 标签统计 hmm 090403*/
.home .labelModule {
    background: #F2F5FA;
    border: 1px solid #D6E0F0;
    border-radius: 10px;
    display: inline-block;
    width: 100%;
    padding: 20px;
}

.home .labelModule:first-child {
    margin-bottom: 20px;
}

.home .labelModule ul li {
    width: 100%;
    font-size: 16px;
    color: #63717A;
    text-align: center
}

.home .labelModule ul li:first-child {
    margin-bottom: 10px;
}

.home .labelModule ul li font {
    font-size: 41px;
    color: #2D3039;
}

/*公共部分 hmm*/
.p20 {
    padding: 20px;
}

.pb30 {
    padding-bottom: 30px;
}

/*办案类型 数据超出 显示样式 hmm 090404*/

.widthBig .labelModule {
    width: 49.2%;
}

.widthBig .labelModule:first-child {
    margin-bottom: 30px;
    margin-right: 20px;
}

.widthSmall {
    float: right;
}
</style>
